import { Route,Navigate } from "react-router-dom";
import React from "react";

export const PrivateRoute = ({ element: Component, ...rest }) => {
  const isLoggedIn = !!localStorage.getItem('token');
  const userAuth = localStorage.getItem('loginPermissions');



  return (
    <>
      {isLoggedIn && userAuth ? <Component /> : <Navigate to="/" />}
    </>
  );
};


// export const withPermission = (WrappedComponent, requiredPermissions) => {
//   return (props) => {
//     const userPermissions = localStorage.getItem("loginPermissions");
//     const userPermissionArray = userPermissions.split(",");

//     // Check if user permissions include all required permissions
//     const hasPermission = requiredPermissions.every((permission) =>
//       userPermissionArray.includes(permission.trim())
//     );

//     console.log(userPermissions)

//     if (hasPermission) {
//       // If user has required permissions, render the component
//       return <WrappedComponent {...props} />;
//     } else {
//       // If user does not have required permissions, redirect to home page or another route
//       return <Navigate to="/" replace />;
//     }
//   };
// };